import type { CalculationInstallmentRow } from './step-calculation.types';

/** Valores fictícios exibidos com blur quando a UW bloqueia o cálculo (status 17). */
export const CAPITAL_GLOBAL_UNDER_ANALYSIS_PLACEHOLDER_INSTALLMENTS: CalculationInstallmentRow[] =
  [
    { periodicity: 'Mensal', premiumValue: 'R$ 210,83' },
    { periodicity: 'Bimestral', premiumValue: 'R$ 421,67' },
    { periodicity: 'Trimestral', premiumValue: 'R$ 632,50' },
    { periodicity: 'Quadrimestral', premiumValue: 'R$ 843,33' },
    { periodicity: 'Semestral', premiumValue: 'R$ 1.265,00' },
    { periodicity: 'Anual', premiumValue: 'R$ 2.530,00' },
  ];
